module.exports = __webpack_public_path__ + "static/media/img_qudao7@2x.6441da36.png";